import * as React from "react";
const SvgArrows = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 36,
	viewBox: "0 0 24 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M17 14.5L12 9.5L7 14.5H17Z",
	fill: "#333333",
	fillOpacity: .5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 21.5L12 26.5L17 21.5H7Z",
	fill: "#333333",
	fillOpacity: .5
}));
export default SvgArrows;
